import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=67dce1d6&scoped=true"
import script from "./rank.vue?vue&type=script&lang=ts"
export * from "./rank.vue?vue&type=script&lang=ts"
import style0 from "./rank.vue?vue&type=style&index=0&id=67dce1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dce1d6",
  null
  
)

export default component.exports